import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const UserIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      d="M17.466 17.663a1.239 1.239 0 0 1-.968.473H3.06c-.374 0-.736-.177-.967-.473a1.088 1.088 0 0 1-.213-.946 8.117 8.117 0 0 1 7.9-6.182 8.116 8.116 0 0 1 7.9 6.182c.08.332.005.668-.213.946zM5.979 5.666c0-2.095 1.704-3.8 3.8-3.8 2.095 0 3.8 1.705 3.8 3.8 0 2.096-1.705 3.8-3.8 3.8a3.804 3.804 0 0 1-3.8-3.8zm12.738 10.795a9.178 9.178 0 0 0-6.398-6.641 4.872 4.872 0 0 0 2.33-4.154 4.875 4.875 0 0 0-4.87-4.87 4.875 4.875 0 0 0-4.87 4.87c0 1.756.935 3.296 2.331 4.154A9.178 9.178 0 0 0 .842 16.46a2.16 2.16 0 0 0 .409 1.86 2.282 2.282 0 0 0 1.809.883h13.439c.71 0 1.37-.32 1.809-.882a2.16 2.16 0 0 0 .409-1.86z"
    />
  </svg>
);

UserIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

UserIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(19, 20),
};

export default UserIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/user.js